/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zombie_Hero_Sub_ColdInputs */

const en_zombie_hero_sub_cold = /** @type {(inputs: Zombie_Hero_Sub_ColdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I can't do it. It's still you.`)
};

const zh_zombie_hero_sub_cold = /** @type {(inputs: Zombie_Hero_Sub_ColdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我做不到。那还是你。`)
};

/**
* | output |
* | --- |
* | "I can't do it. It's still you." |
*
* @param {Zombie_Hero_Sub_ColdInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const zombie_hero_sub_cold = /** @type {((inputs?: Zombie_Hero_Sub_ColdInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zombie_Hero_Sub_ColdInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_zombie_hero_sub_cold(inputs)
	return zh_zombie_hero_sub_cold(inputs)
});
export { zombie_hero_sub_cold as "zombie.hero.sub_cold" }